<ng-container *ifScreenSize="screenType.Mobile">
  <ng-container *ngIf="isHomePage; else pageHeader">
    <ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
      <div class="mobile-page-header-curve" [ngClass]="{ 'show-after': showAfter, 'has-loyalty-feed': hasLoyaltyFeed$ | async }">
        <div class="mobile-page-header">
          <div class="mobile-page-header-stack d-flex flex-column h-100">
            <!-- Name and ID -->
            <div class="d-flex justify-content-between align-items-center gap-2">
              <div class="card-id text-start">
                <h5
                  class="mb-0 card-name text-white text-uppercase"
                  [ngClass]="nameSizeClass(memberDetails.FirstName + ' ' + memberDetails.Surname)"
                  *ngIf="memberDetails$ | async as memberDetails"
                >
                  {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
                </h5>
                <div class="card-name-info text-white">
                  {{ 'member.card.id.label' | translate : { fgbdefault: 'ID' } }} : {{ memberCard.MemberId }}
                </div>
              </div>
              <button class="btn d-flex btn-redirect-wallet bg-glass-dark" [routerLink]="'/rewards/wallet'">
                <span class="icon material-symbols-outlined">qr_code_scanner</span>
                <span class="text-white font-size-14">{{
                  'member.card.redemption.history' | translate : { fgbdefault: 'Redemption History' }
                }}</span>
              </button>
            </div>

            <!-- Upgrade Now -->
            <a
              class="btn upgrade-btn bg-glass-dark text-white w-100 d-flex align-items-center justify-content-center"
              [routerLink]="'/membership'"
              *inProductCode="[productCode.Free]"
            >
              {{ 'member.card.upgrade.now' | translate : { fgbdefault: 'Upgrade Now' } }}
            </a>

            <!-- Payment widget -->
            <ng-container *ngIf="cardToken$ | async as cardToken; else addCardRef">
              <a
                class="payment-widget bg-glass-dark d-flex align-items-center justify-content-between w-100"
                [ngClass]="{ 'bg-frozen': cardToken.Frozen }"
                [routerLink]="'/account'"
              >
                <div class="card-token-number text-white d-flex align-items-center">
                  <ng-container [ngSwitch]="cardToken?.CardType">
                    <img class="card-type-image visa" *ngSwitchCase="3" [src]="'payment-icons/visa.svg' | contentAssetImage" />
                    <img class="card-type-image" *ngSwitchCase="1" [src]="'payment-icons/mastercard.svg' | contentAssetImage" />
                    <img class="card-type-image" *ngSwitchCase="2" [src]="'payment-icons/amex.svg' | contentAssetImage" />
                    <img class="card-type-image" *ngSwitchCase="4" [src]="'payment-icons/discover.svg' | contentAssetImage" />
                    <img class="card-type-image" *ngSwitchCase="5" [src]="'payment-icons/jcb.svg' | contentAssetImage" />
                    <img class="card-type-image" *ngSwitchCase="7" [src]="'payment-icons/dinnersclub.svg' | contentAssetImage" />
                    <img class="card-type-image" *ngSwitchCase="8" [src]="'payment-icons/unionpay.svg' | contentAssetImage" />
                  </ng-container>
                  <span class="card-digits">({{ cardToken.CardNumber.substr(12) }})</span>
                  <span class="expiry"
                    >{{ 'member.card.expiry.date' | translate }} {{ cardToken.ExpiryDate | date : 'MM/YY' }}</span
                  >
                </div>
                <span class="icon material-icons text-white">keyboard_arrow_right</span>
              </a>
            </ng-container>
            <ng-template #addCardRef>
              <a
                class="payment-widget bg-glass-dark d-flex align-items-center justify-content-center w-100 text-white"
                [routerLink]="'/account'"
              >
                <span class="icon material-icons pe-2">add_card</span>
                <span class="font-size-14 font-heading">{{ 'member.card.ecash.add' | translate }}</span>
              </a>
            </ng-template>

            <!-- Quick navigation -->
            <div class="mobile-navigation-wrapper" [class.has-overflow]="hasOverflow && !isScrolledToEnd">
              <div
                #mobileNavigation
                class="mobile-navigation d-flex flex-row align-items-center"
                (scroll)="onNavigationScroll()"
              >
                <div class="navigation" routerLink="/rewards">
                  <span class="icons material-symbols-outlined filled bg-glass-dark">redeem</span>
                  <a class="text-white font-size-14">{{ 'member.card.rewards' | translate }}</a>
                </div>
                <div class="navigation" routerLink="/challenges">
                  <span class="icons material-symbols-outlined filled bg-glass-dark">emoji_events</span>
                  <a class="text-white font-size-14">{{ 'member.card.challenges' | translate }}</a>
                </div>
                <div class="navigation" routerLink="/games">
                  <span class="icons material-symbols-outlined filled bg-glass-dark">sports_esports</span>
                  <a class="text-white font-size-14">{{ 'member.card.games' | translate }}</a>
                </div>
                <div class="navigation" routerLink="/benefits">
                  <span class="icons material-symbols-outlined filled bg-glass-dark">rewarded_ads</span>
                  <a class="text-white font-size-14">{{ 'member.card.benefits' | translate : { fgbdefault: 'Benefits' } }}</a>
                </div>
                <div class="navigation" routerLink="/newsletters">
                  <span class="icons material-symbols-outlined filled bg-glass-dark">newsmode</span>
                  <a class="text-white font-size-14">{{ 'member.card.newsletter' | translate : { fgbdefault: 'Newsletter' } }}</a>
                </div>
                <div class="navigation" routerLink="/gallery">
                  <span class="icons material-symbols-outlined filled bg-glass-dark">animated_images</span>
                  <a class="text-white font-size-14">{{ 'member.card.gallery' | translate : { fgbdefault: 'Gallery' } }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #loadingRef>
      <fgb-loading></fgb-loading>
    </ng-template>
  </ng-container>

  <ng-template #pageHeader>
    <div class="page-header" [ngClass]="{ 'hide-footer': !showAfter }">
      <div class="d-flex align-items-center justify-content-between text-white">
        <div class="d-flex align-items-center">
          <a (click)="goBack()" class="btn back-btn text-white px-0">
            <span class="icon material-icons" aria-hidden="true">arrow_back_ios</span>
          </a>
          <h4 class="page-header-title mb-0 fw-bold text-white">
            {{ pageTitle | translate | uppercase }}
          </h4>
        </div>
        <div class="d-flex align-items-center gap-2" *ngIf="showBalance">
          <div class="points-pill d-flex align-items-center gap-1 bg-glass-dark">
            <span class="material-icons points-icon text-white" aria-hidden="true">loyalty</span>
            <span class="fw-bold font-size-14 text-white">{{ loyaltyPointsCard$ | async | FortressCurrencyPipe : 'PTS' }}</span>
          </div>
          <a
            [routerLink]="'/rewards/wallet'"
            class="qr-btn bg-glass-dark-medium d-flex align-items-center justify-content-center"
          >
            <span class="material-icons text-white font-size-20">qr_code_scanner</span>
          </a>
        </div>
      </div>
      <div class="footer"></div>
    </div>
  </ng-template>
</ng-container>
